module.exports = __webpack_public_path__ + "img/auto-badge.119a5152.png";